module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/poster.bc3d3689.jpg";